export const healthReport = {
  seatBeltLowBattery: "安全带传感器低电量",
  speedSensorLowBattery: "速度传感器低电量",
  SDCardError: "SD卡异常",
  extendSDCardError: "扩展SD卡异常",
  cameraError: "摄像头异常",
  cameraErrorDetail: "{0}异常",
  allHealthReportType: "全部AI主机异常",
  reportType: "报告类型",
  time: "时间",
  detail: "详情",
  lowBatteryErrorDetail: "剩余电量：{0}%",
};
